HTMLElement.prototype.$ = function (selector) {
    return this.querySelector(selector);
};
HTMLElement.prototype.$$ = function (selector) {
    return Array.from(this.querySelectorAll(selector));
};
HTMLElement.prototype.$removeClass = function () {
    var _a;
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    // const c = [...classes].flat().join(" ");
    // console.log(c)
    (_a = this.classList).remove.apply(_a, classes);
    // console.log(this.classList)
    return this;
};
HTMLElement.prototype.$addClass = function () {
    var _a;
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    (_a = this.classList).add.apply(_a, classes);
    return this;
};
HTMLElement.prototype.$classAddOrRemoveIf = function (condition, className) {
    this.classList[condition ? 'add' : 'remove'](className);
    return this;
};
HTMLElement.prototype.$addStyle = function (style) {
    this.style = style;
    return this;
};
